import { colors } from '../../../theme/colors';
import { typography } from '../../../theme/typography';

export const formatOptions = (options = []) => {
  return options.map((opt) =>
    typeof opt === 'string' || typeof opt === 'number'
      ? { value: opt, label: String(opt) }
      : opt
  );
};

export const findSelectedOption = (formattedOptions = [], value) => {
  return formattedOptions.find((opt) => opt.value === value) || null;
};

const getFontSize = (size) => {
  if (size === 'sm') return '15px';
  if (size && typography[size] && typography[size].fontSize) {
    return typography[size].fontSize;
  }
  return '14px';
};

export const buildCustomStyles = ({ disabled, error, size }) => {
  const fontSize = getFontSize(size);

  return {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: disabled ? colors.brandOffWhite : '#ffffff',
      border: `1px solid ${
        error
          ? colors.error
          : state.isFocused
          ? colors.brandLightBlue
          : '#e0e0e0'
      }`,
      borderRadius: '6px',
      boxShadow: state.isFocused
        ? `0 0 0 3px ${
            error ? 'rgba(220, 53, 69, 0.25)' : 'rgba(0, 169, 255, 0.25)'
          }`
        : 'none',
      cursor: disabled ? 'not-allowed' : 'text',
      minHeight: size === 'sm' ? '42px' : 'auto',
      padding: '2px 0',
      opacity: 1,
      transition: 'border-color 0.2s, box-shadow 0.2s',
      '&:hover': {
        borderColor: disabled
          ? '#e0e0e0'
          : error
          ? colors.error
          : '#b5b5b5',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      color: colors.dark,
      fontSize,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: colors.dark,
      fontSize,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: colors.brandMediumGray,
      fontSize,
      fontStyle: 'normal',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: colors.brandMediumGray,
      padding: '0 8px',
      '&:hover': {
        color: colors.brandDarkBlue,
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: colors.brandMediumGray,
      padding: '0 8px',
      '&:hover': {
        color: colors.error,
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#ffffff',
      borderRadius: '6px',
      border: '1px solid #e0e0e0',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      marginTop: '4px',
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? colors.brandLightBlue
        : state.isFocused
        ? colors.brandIce
        : 'transparent',
      color: state.isSelected ? '#FFF' : colors.dark,
      fontSize,
      cursor: 'pointer',
      padding: '8px 12px',
      '&:active': {
        backgroundColor: colors.brandLightBlue,
        color: '#FFF',
      },
    }),
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/AutoCompleteSelect/utils/autoCompleteHelpers.js